import React from "react";

// Convert 24-hour time to 12-hour AM/PM format
const convertTo12Hour = (time24) => {
  try {
    if (!time24 || !time24.includes(':')) {
      return time24 || 'N/A';
    }

    // Remove timezone info if present (e.g., "05:30 (EST)")
    const timeOnly = time24.split(" ")[0];
    const [hours, minutes] = timeOnly.split(":");
    const hour = parseInt(hours, 10);

    if (isNaN(hour)) {
      return time24;
    }

    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  } catch (error) {
    console.error("Error converting time:", error);
    return time24;
  }
};

const PrayerTimesTable = ({ prayerTimes }) => {
  // Validate prayerTimes prop
  if (!prayerTimes || !prayerTimes.timings) {
    console.error("Invalid prayerTimes data");
    return null;
  }

  const { timings } = prayerTimes;

  const prayers = [
    ["Fajr", timings.Fajr],
    ["Dhuhr", timings.Dhuhr],
    ["Asr", timings.Asr],
    ["Maghrib/ Sunset", timings.Maghrib],
    ["Isha", timings.Isha],
  ];

  return (
    <div className="prayer-times-table">
      <table>
        <tbody>
          <tr><th>Prayer</th><th>Times</th></tr>
          {prayers.map(([name, time]) => (
            <tr key={name}>
              <td>{name}</td>
              <td>{convertTo12Hour(time)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PrayerTimesTable;
